<template>
  <div>
    <table class="table table-sm table-bordered">
      <thead class="thead-light">
        <tr>
          <th class="w-15">{{ "account" | translate }}</th>
          <th>{{ "type" | translate }}</th>
          <th class="w-20">{{ "in" | translate }}</th>
          <th class="w-20">{{ "out" | translate }}</th>
          <th class="w-30">{{ "balance" | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(data, index) in summary" :key="index">
          <td>{{ data[0] | translate | uppercase }}</td>
          <td>{{ data[1][0]["accountType"] | translate }}</td>
          <td class="text-right">
            <div
              v-for="(currency, cuIndex) in currencyList(data[1])"
              :key="'in' + cuIndex"
            >
              {{ calIn(data[1], currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </td>
          <td class="text-right">
            <div
              v-for="(currency, cuIndex) in currencyList(data[1])"
              :key="'out' + cuIndex"
            >
              {{ calOut(data[1], currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </td>
          <td class="text-right font-weight-bold">
            <div
              v-for="(currency, cuIndex) in currencyList(data[1])"
              :key="'bal' + cuIndex"
            >
              {{ calBalance(data[1], currency) | number(2) }}
              {{ currency | translate }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["summary"],

  data() {
    return {
      showDetail: false,
    };
  },

  methods: {
    calIn(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.in) {
            sum += trans.in;
          }
        }
        return sum;
      }, 0);
    },
    calOut(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.out) {
            sum += trans.out;
          }
        }
        return sum;
      }, 0);
    },
    calBalance(transactions, currency) {
      return transactions.reduce((sum, trans) => {
        if (trans.currency === currency) {
          if (trans.in) {
            sum += trans.in;
          }
          if (trans.out) {
            sum -= trans.out;
          }
        }
        return sum;
      }, 0);
    },
    currencyList(transactions) {
      return [...new Set(transactions.map((trn) => trn.currency))];
    },
  },
};
</script>
